<template>
  <div
    class="index"
    v-if="!logged"
  >
    <div class="title">欢迎使用<br><span>小阿-学习计划</span></div>
    <div class="side-title">每一次成长，都为遇见更好的自己</div>
    <div class="input-wrap">
      <div class="input-item">
        <!-- <img
          src="../statics/img/act.png"
          alt=""
        /> -->
        <input
          type="text"
          v-model="account"
          placeholder="使用核心系统账号登陆"
        />
      </div>
      <div class="input-item">
        <!-- <img
          src="../statics/img/psw.png"
          alt=""
        /> -->
        <input
          type="password"
          v-model="password"
          placeholder="使用核心系统账号密码登陆"
        />
      </div>
    </div>
    <div
      class="button"
      @click="login"
    >开启旅程<i class="el-icon-right"></i></div>
  </div>
</template>
<script>
import { getQueryString } from '../../project/src/constant/utils'

export default {
  data() {
    return {
      account: '',
      password: '',
      logged: false,
    }
  },
  methods: {
    login() {
      return app
        .authenticate({
          account: this.account,
          password: this.password,
          strategy: 'local',
        })
        .then(({ accessToken }) => {
          this.logged = true
          // 登录成功恢复计时
          app.setLoginInterval()
          return app.emit('login', { accessToken })
        })
        .catch((e) => {
          this.$msgbox('登录失败！')
          console.log('error', e)
          return false
        })
    },
  },
  mounted() {
    const ifMobile = Boolean(getQueryString('ifMobile'))
    if (ifMobile) {
      const jwt = getQueryString('jwt')
      if (jwt) {
        let cookie
        cookie = `feathers-jwt=${jwt};expires=`
        cookie += new Date(Date.now() + 1000 * 60 * 60 * 24).toGMTString()
        document.cookie = cookie
        location.hash = '#/chuangguan?ifMobile=1'
        window.location.reload()
        this.logged = true
      }
    }
  },
}
</script>
<style scoped>
.index {
  width: 100vw;
  height: 100vh;
  padding: 111px 24px 42px;
  position: relative;
  background-image: url('https://alphahr-files-backup.oss-cn-beijing.aliyuncs.com/wechat/jobHunting/newChuangguan/bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: #2c2959;
}
.title {
  font-size: 33px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 37px;
  text-align: center;
}
.title span {
  color: #0090f1;
}
.side-title {
  font-size: 19px;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
}
.input-wrap {
  width: 328px;
  margin: 0 auto;
  margin-top: 96px;
}
.input-item {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  height: 47px;
  background: #070a0c;
  border-radius: 20px;
  /* border: 1px solid #ffffff; */
  padding: 0 23px;
}
.input-item img {
  width: 16px;
  height: 18px;
  display: block;
  margin-right: 26px;
}
.input-item input {
  background-color: transparent;
  font-size: 18px;
  color: #fff;
  line-height: 47px;
  border: none;
  text-align: center;
  width: 100%;
}
.button {
  /* position: absolute; */
  /* bottom: 42px; */
  /* left: 50%; */
  /* margin-left: -150px; */
  width: 328px;
  height: 47px;
  background: linear-gradient(90deg, #e4035d 0%, #38adfd 100%);
  border-radius: 4px;
  font-size: 22px;
  font-weight: 600;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 24px auto;
}
.button i {
  position: absolute;
  right: 14px;
  top: 6px;
  color: #fff;
  font-size: 34px;
}
</style>
